import { shareColumnsExtend, shareFormColumnsExtend } from '../share';

const entityColumns = {
  id: {
    model_name: 'Walk::StepRecord',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Walk::StepRecord',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Walk::StepRecord',
    column_type: 'datetime',
  },
  date: {
    model_name: 'Walk::StepRecord',
    column_type: 'date',
  },
  step: {
    model_name: 'Walk::StepRecord',
    column_type: 'integer',
  },
  device_id: {
    model_name: 'Walk::StepRecord',
    column_type: 'string',
  },
  is_active: {
    model_name: 'Walk::StepRecord',
    column_type: 'boolean',
  },
  miapay_wallet_holder: {
    model_name: 'Walk::StepRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'miapay_wallet_holder',
      model_name: 'Miapay::WalletHolder',
      foreign_key: 'miapay_wallet_holder_id',
    },
  },
  miapay_wallet_holder_id: {
    model_name: 'Walk::StepRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'miapay_wallet_holder',
      model_name: 'Miapay::WalletHolder',
      foreign_key: 'miapay_wallet_holder_id',
    },
  },
  error_message: {
    model_name: 'Walk::StepRecord',
    column_type: 'string',
  },
  error_message_code: {
    model_name: 'Walk::StepRecord',
    column_type: 'enum',
  },
  first_wallet_holder_of_the_same_device: {
    model_name: 'Walk::StepRecord',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
